import React from 'react';

const IconOrientationChaiseArmFacingLeft = () => (
  <svg
    width="80"
    height="66"
    viewBox="0 0 80 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0H7H13H51H74V26H6V0ZM13 6H51V2H72V24H13V6Z"
      fill="#424242"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.8566 37.2889C45.8566 37.2889 45.9525 36.235 46.0004 35.229C46.0483 34.223 45.9525 33.6961 45.9045 33.3607C45.8566 33.0254 45.3297 31.9715 44.9465 32.0194C44.5632 32.0673 44.18 32.3547 43.4614 33.8398C43.4614 33.8398 43.2219 34.4146 43.4614 35.708C43.701 37.0014 43.7489 37.5284 43.7489 37.5284L45.8566 37.2889Z"
      fill="#581A04"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.4553 57.9355C34.4553 57.9355 33.8804 57.2648 33.4014 57.5043C32.9223 57.7438 32.7307 58.4145 32.7786 59.3726C32.8265 60.3307 32.9702 60.9055 33.3535 61.4804C33.7367 62.0552 34.8864 63.3486 35.0301 63.5403C35.1738 63.7319 35.7487 64.2109 36.2756 63.8756C36.8026 63.5403 36.9463 63.5403 36.9463 63.2049C36.9463 62.8696 34.4553 57.9355 34.4553 57.9355Z"
      fill="#581A04"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.9102 43.8518C46.9102 43.756 46.9102 41.6003 46.9102 41.6003C46.9102 41.6003 46.8623 40.6902 46.5749 40.0195C46.2875 39.3488 45.9043 37.6243 45.9522 37.1931L45.2336 36.8578C45.2336 36.8578 44.8983 36.7141 44.515 36.8578C44.1318 37.0015 43.4611 37.3848 43.4611 37.3848L43.2695 42.5584L46.9102 43.8518Z"
      fill="#485963"
    />
    <mask
      id="mask0"
      maskType="alpha"
      maskUnits="userSpaceOnUse"
      x="43"
      y="36"
      width="4"
      height="8"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.9102 43.8518C46.9102 43.756 46.9102 41.6003 46.9102 41.6003C46.9102 41.6003 46.8623 40.6902 46.5749 40.0195C46.2875 39.3488 45.9043 37.6243 45.9522 37.1931L45.2336 36.8578C45.2336 36.8578 44.8983 36.7141 44.515 36.8578C44.1318 37.0015 43.4611 37.3848 43.4611 37.3848L43.2695 42.5584L46.9102 43.8518Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.9523 43.5644C45.9523 43.5644 46.096 41.0734 46.096 40.8339C46.096 40.5896 45.9044 39.78 45.7128 39.1094C45.5212 38.4387 44.8984 36.2351 44.8984 36.2351L47.5811 36.81V42.8459L47.1499 44.2351L45.9523 43.5644Z"
        fill="#10171A"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.2936 53.6241V53.9115C47.2936 53.9115 46.9103 54.1989 46.9582 54.6301C47.0061 55.0612 47.3894 54.9654 47.3894 54.9654C47.3894 54.9654 47.5058 54.8771 47.581 55.2528C47.6289 55.4923 47.6768 56.4983 47.6768 56.4983C47.6768 56.4983 47.7488 56.6839 47.9163 56.642C48.1079 56.5941 48.4433 56.163 48.5391 55.684C48.6349 55.2049 48.7786 54.1989 48.5391 53.8636L48.3475 53.5762L47.2936 53.6241Z"
      fill="#EABD87"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.5269 43.2768L30.479 43.0373C30.479 43.0373 30.3832 42.2708 30.5269 41.8876C30.6707 41.5044 31.0539 41.0732 31.6287 41.0732C31.6287 41.0732 31.8204 41.0732 31.9641 41.1691C32.1078 41.2649 32.2036 41.3128 32.2994 41.3128C32.3952 41.3128 32.5492 41.2254 32.5868 41.1691C32.6826 41.0253 32.8742 41.0732 32.8742 41.217C32.8742 41.3607 32.7784 41.6002 32.6347 41.7918C32.491 41.9834 32.3473 42.1271 32.2515 42.2708C32.1557 42.4146 31.6287 43.0373 31.6287 43.181C31.6287 43.3247 31.5808 43.3247 31.5808 43.3247L30.5269 43.2768Z"
      fill="#EABD87"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.563 39.3967C44.3714 38.9177 43.8924 39.3488 43.8924 39.3488C43.8924 39.3488 38.8145 40.3069 38.6756 40.6751L38.3834 39.3967C38.3834 39.3967 37.9522 39.1093 37.8564 39.4925C37.7606 39.8758 37.8085 40.4985 38.1918 40.9297C38.4118 41.1772 38.5685 41.1878 38.6622 41.152C38.7175 41.5117 38.8624 41.8878 38.8624 41.8878L38.8145 42.0794L39.3415 43.0375L40.8744 43.5165L42.3594 43.4207C42.3594 43.4207 42.4414 43.3336 43.078 42.75C43.6528 42.2231 43.9403 41.2171 43.9403 41.2171L44.084 41.1213C44.4672 40.786 44.7546 39.8758 44.563 39.3967Z"
      fill="#EBB77E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.2278 42.6063C44.2278 42.6063 47.5331 43.6122 48.1559 44.0913C48.7787 44.5703 48.9703 45.1931 48.9703 45.7679C48.9703 46.3428 48.6349 49.2649 48.587 49.7919C48.5391 50.3188 48.3475 53.0494 48.5391 53.6721C48.5391 53.6721 48.0122 54.1512 47.102 53.6721C47.102 53.6721 47.2457 50.223 46.8146 49.217C46.8146 49.217 46.1918 52.9057 45.2817 54.0075C44.3715 55.1092 43.126 55.6841 41.8805 55.5883C40.6349 55.4925 39.3415 55.3009 39.3415 55.3009C39.3415 55.3009 38.5751 55.1572 38.4793 55.4925C38.3834 55.8278 38.1439 57.0733 37.9523 59.4206C37.7607 61.7679 37.5691 62.8218 37.5691 62.8218C37.5691 62.8218 37.5212 63.253 36.8984 63.3488C36.2757 63.4446 35.8445 63.4446 35.5571 63.3488C35.2697 63.253 34.599 62.5823 34.5511 62.4386C34.5032 62.2949 34.2637 55.732 33.9763 55.1092C33.6888 54.4865 32.9703 51.0853 33.9284 49.6003L34.4074 48.8338C34.4074 48.8338 34.0242 48.8338 33.5451 49.0733C33.0661 49.3128 30.3834 49.6961 30.096 47.6362C29.8086 45.5763 30.4793 43.229 30.4793 43.229H31.7248C31.7248 43.229 31.5811 44.3787 32.108 44.5224C32.6349 44.6661 33.0661 43.9476 33.2577 43.756C33.4493 43.5643 33.7846 43.0374 35.7966 42.8937C37.8086 42.75 38.1439 42.5583 38.1439 42.5583L40.8745 43.8039L42.8864 43.2769L44.2278 42.6063Z"
      fill="#008F90"
    />
    <mask
      id="mask1"
      maskType="alpha"
      maskUnits="userSpaceOnUse"
      x="30"
      y="42"
      width="19"
      height="22"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.2278 42.6063C44.2278 42.6063 47.5331 43.6122 48.1559 44.0913C48.7787 44.5703 48.9703 45.1931 48.9703 45.7679C48.9703 46.3428 48.6349 49.2649 48.587 49.7919C48.5391 50.3188 48.3475 53.0494 48.5391 53.6721C48.5391 53.6721 48.0122 54.1512 47.102 53.6721C47.102 53.6721 47.2457 50.223 46.8146 49.217C46.8146 49.217 46.1918 52.9057 45.2817 54.0075C44.3715 55.1092 43.126 55.6841 41.8805 55.5883C40.6349 55.4925 39.3415 55.3009 39.3415 55.3009C39.3415 55.3009 38.5751 55.1572 38.4793 55.4925C38.3834 55.8278 38.1439 57.0733 37.9523 59.4206C37.7607 61.7679 37.5691 62.8218 37.5691 62.8218C37.5691 62.8218 37.5212 63.253 36.8984 63.3488C36.2757 63.4446 35.8445 63.4446 35.5571 63.3488C35.2697 63.253 34.599 62.5823 34.5511 62.4386C34.5032 62.2949 34.2637 55.732 33.9763 55.1092C33.6888 54.4865 32.9703 51.0853 33.9284 49.6003L34.4074 48.8338C34.4074 48.8338 34.0242 48.8338 33.5451 49.0733C33.0661 49.3128 30.3834 49.6961 30.096 47.6362C29.8086 45.5763 30.4793 43.229 30.4793 43.229H31.7248C31.7248 43.229 31.5811 44.3787 32.108 44.5224C32.6349 44.6661 33.0661 43.9476 33.2577 43.756C33.4493 43.5643 33.7846 43.0374 35.7966 42.8937C37.8086 42.75 38.1439 42.5583 38.1439 42.5583L40.8745 43.8039L42.8864 43.2769L44.2278 42.6063Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.4852 43.5164C47.4852 43.5164 46.6229 46.678 46.8145 49.217C47.0061 51.7559 46.7666 54.1032 46.7666 54.1032L49.8325 54.2948C49.8325 54.2948 49.8325 43.9475 49.7367 43.8996C49.6409 43.8517 47.4852 43.5164 47.4852 43.5164Z"
        fill="#0E1918"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4494 49.5522L37.8087 52.2828C37.8087 52.2828 39.9644 53.5762 42.0722 52.7618C44.18 51.9475 46.8147 50.0313 46.8147 50.0313L45.8566 56.4025L39.0063 63.8756L33.2578 63.7319L33.4494 49.5522Z"
        fill="#495963"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.8147 42.0793L38.144 42.5584C38.144 42.5584 38.9544 44.1849 41.2099 44.235C43.3656 44.2829 44.2279 42.6063 44.2279 42.6063L43.5572 42.1272C43.5572 42.1272 42.5033 43.5644 41.0662 43.4207C39.6291 43.277 38.8147 42.0793 38.8147 42.0793Z"
      fill="#69B2B2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.084 39.3247C44.084 41.4281 42.7864 43.1331 41.1858 43.1331C39.5852 43.1331 38.2876 41.4281 38.2876 39.3247C38.2876 37.2215 39.5852 35.5164 41.1858 35.5164C42.7864 35.5164 44.084 37.2215 44.084 39.3247Z"
      fill="#0B0C0A"
    />
    <mask
      id="mask2"
      maskType="alpha"
      maskUnits="userSpaceOnUse"
      x="30"
      y="42"
      width="19"
      height="22"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.1559 44.0913C48.7787 44.5703 48.9703 45.1931 48.9703 45.7679C48.9703 46.3428 48.6349 49.2649 48.587 49.7919C48.5391 50.3188 48.3475 53.0494 48.5391 53.6721C48.5391 53.6721 48.0122 54.1512 47.102 53.6721C47.102 53.6721 47.2457 50.223 46.8146 49.217C46.8146 49.217 46.1918 52.9057 45.2817 54.0075C44.3715 55.1092 43.126 55.6841 41.8805 55.5883C40.6349 55.4925 39.3415 55.3009 39.3415 55.3009C39.3415 55.3009 38.5751 55.1572 38.4793 55.4925C38.3834 55.8278 38.1439 57.0733 37.9523 59.4206C37.7607 61.7679 37.5691 62.8218 37.5691 62.8218C37.5691 62.8218 37.5212 63.253 36.8984 63.3488C36.2757 63.4446 35.8445 63.4446 35.5571 63.3488C35.2697 63.253 34.599 62.5823 34.5511 62.4386C34.5032 62.2949 34.2637 55.732 33.9763 55.1092C33.6888 54.4865 32.9703 51.0853 33.9284 49.6003L34.4074 48.8338C34.4074 48.8338 34.0242 48.8338 33.5451 49.0733C33.0661 49.3128 30.3834 49.6961 30.096 47.6362C29.8086 45.5763 30.4793 43.229 30.4793 43.229H31.7248C31.7248 43.229 31.5811 44.3787 32.108 44.5224C32.6349 44.6661 33.0661 43.9476 33.2577 43.756C33.4493 43.5643 33.7846 43.0374 35.7966 42.8937C37.8086 42.75 38.1439 42.5583 38.1439 42.5583L40.8745 43.8039L42.8864 43.2769L44.2278 42.6063C44.2278 42.6063 47.5331 43.6122 48.1559 44.0913Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3641 49.2673C31.4273 49.2674 30.2786 48.9446 30.096 47.6363C30.0453 47.2732 30.0245 46.9012 30.0244 46.5346C30.0243 45.3179 30.2538 44.1619 30.3869 43.5942C31.4506 46.4106 32.4344 46.7261 33.2577 46.7261C34.12 46.7261 35.126 45.768 35.126 45.768C36.1799 47.78 34.5156 48.7555 34.5156 48.7555L34.4039 48.834C34.3643 48.8347 33.9974 48.8473 33.5451 49.0734C33.3703 49.1608 32.9022 49.2673 32.3641 49.2673Z"
        fill="#204948"
      />
    </g>
    <mask
      id="mask3"
      maskType="alpha"
      maskUnits="userSpaceOnUse"
      x="30"
      y="42"
      width="19"
      height="22"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.9703 45.768C48.9703 45.1931 48.7787 44.5704 48.1559 44.0913C47.5331 43.6123 44.2278 42.6063 44.2278 42.6063L43.5571 42.1272C43.5571 42.1272 42.5032 43.5644 41.0661 43.4207C39.629 43.277 38.8146 42.0793 38.8146 42.0793L38.1439 42.5584C38.1439 42.5584 37.8086 42.75 35.7966 42.8937C33.7846 43.0374 33.4493 43.5644 33.2577 43.756C33.0661 43.9476 32.6349 44.6662 32.108 44.5225C31.5811 44.3787 31.7248 43.229 31.7248 43.229H30.4793C30.4793 43.229 29.8086 45.5764 30.096 47.6362C30.3834 49.6961 33.0661 49.3129 33.5451 49.0734C34.0242 48.8338 34.4074 48.8338 34.4074 48.8338L33.9284 49.6003C32.9703 51.0853 33.6888 54.4865 33.9763 55.1093C34.2637 55.732 34.5032 62.2949 34.5511 62.4386C34.599 62.5823 35.2697 63.253 35.5571 63.3488C35.8445 63.4446 36.2757 63.4446 36.8984 63.3488C37.5212 63.253 37.5691 62.8219 37.5691 62.8219C37.5691 62.8219 37.7607 61.768 37.9523 59.4207C38.1439 57.0734 38.3834 55.8278 38.4793 55.4925C38.5751 55.1572 39.3415 55.3009 39.3415 55.3009C39.3415 55.3009 40.6349 55.4925 41.8805 55.5883C43.126 55.6841 44.3715 55.1093 45.2817 54.0075C46.1918 52.9057 46.8146 49.2171 46.8146 49.2171C47.2457 50.2231 47.102 53.6722 47.102 53.6722C48.0122 54.1512 48.5391 53.6722 48.5391 53.6722C48.3475 53.0494 48.5391 50.3189 48.587 49.7919C48.6349 49.265 48.9703 46.3428 48.9703 45.768L35.5571 54.2949Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5799 53.0311C39.0554 53.0311 37.8084 52.2828 37.8084 52.2828L37.3545 51.9985C37.3765 51.8626 37.5231 51.8976 38.8623 50.5583C40.6827 48.7379 41.5929 45.5763 41.8324 44.5703C41.8509 44.4925 41.8402 44.3566 41.8152 44.2014C43.5285 43.9658 44.2276 42.6062 44.2276 42.6062C44.2276 42.6062 46.254 43.223 47.4325 43.7206C47.2482 44.4593 46.6518 47.0624 46.8144 49.217C46.8144 49.217 46.7493 49.6029 46.6303 50.1625C45.9967 50.6082 43.8474 52.0759 42.0719 52.7619C41.5672 52.9569 41.0598 53.0311 40.5799 53.0311Z"
        fill="#007877"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.4521 53.7721C48.518 53.7158 48.5521 53.6721 48.5521 53.6721C48.5521 53.6721 48.5181 53.7158 48.4521 53.7721Z"
        fill="#2D2E2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.8794 53.8851C48.1538 53.885 48.3487 53.7965 48.4524 53.7336C48.3487 53.7965 48.1538 53.885 47.8794 53.8851Z"
        fill="#DC9559"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.8789 53.8851C47.8788 53.8851 47.8787 53.8851 47.8785 53.8851C47.6678 53.885 47.41 53.8328 47.1107 53.6768C47.1085 53.6757 47.1064 53.6746 47.1043 53.6735C47.1035 53.673 47.1027 53.6726 47.1018 53.6722C47.1018 53.6722 47.1249 53.1193 47.1248 52.3916C47.1248 51.3019 47.0729 49.8203 46.8144 49.2171C46.6518 47.0625 47.2482 44.4594 47.4325 43.7207C47.7591 43.8586 48.0205 43.9874 48.1557 44.0913C48.7785 44.5704 48.9701 45.1931 48.9701 45.768C48.9701 46.3428 48.6348 49.265 48.5869 49.7919C48.5543 50.1498 48.4555 51.5243 48.4555 52.5644C48.4555 53.0557 48.4775 53.4724 48.539 53.6722C48.539 53.6722 48.5094 53.6991 48.4522 53.7337C48.3484 53.7965 48.1536 53.885 47.8792 53.8851C47.8791 53.8851 47.879 53.8851 47.8789 53.8851Z"
        fill="#042B2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.3481 63.4121C36.6836 62.9143 36.8569 60.8808 36.9465 60.5225C37.0423 60.1393 36.9465 56.9297 36.9465 56.1153C36.9465 55.3009 37.2339 52.9057 37.3297 52.283C37.355 52.1184 37.3469 52.0475 37.3548 51.9987L37.8087 52.283C37.8087 52.283 39.0557 53.0312 40.5802 53.0312C41.0601 53.0312 41.5675 52.957 42.0722 52.762C43.8477 52.076 45.997 50.6083 46.6306 50.1626C46.3818 51.3328 45.8976 53.2621 45.2818 54.0075C45.2794 54.0105 45.277 54.0133 45.2746 54.0162C45.2719 54.0195 45.2692 54.0228 45.2664 54.0261C45.2652 54.0275 45.264 54.0289 45.2629 54.0303C44.4204 55.0383 43.2954 55.5985 42.1499 55.5987C42.1498 55.5987 42.1496 55.5987 42.1494 55.5987H42.1494C42.0616 55.5987 41.9738 55.5954 41.8859 55.5888C41.8841 55.5887 41.8823 55.5885 41.8806 55.5884C40.6351 55.4926 39.3417 55.3009 39.3417 55.3009C39.3417 55.3009 39.3416 55.3009 39.3414 55.3009C39.3347 55.2997 39.1746 55.2704 38.9934 55.2703C38.9933 55.2703 38.9932 55.2703 38.9932 55.2703C38.993 55.2703 38.9929 55.2703 38.9927 55.2703C38.778 55.2704 38.5339 55.3116 38.4803 55.4894C38.4803 55.4894 38.4803 55.4894 38.4803 55.4894C38.48 55.4905 38.4797 55.4915 38.4794 55.4926C38.3836 55.8279 38.1441 57.0734 37.9525 59.4207C37.7608 61.768 37.5692 62.8219 37.5692 62.8219C37.5692 62.8219 37.5232 63.2363 36.9345 63.3429C36.9228 63.345 36.9108 63.347 36.8986 63.3488C36.6952 63.3801 36.5123 63.4012 36.3481 63.4121Z"
        fill="#0B2535"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.6284 43.3993C42.7697 43.2005 43.5571 42.1272 43.5571 42.1272L44.2278 42.6062C44.2278 42.6062 43.5287 43.9659 41.8154 44.2014C41.7704 43.9215 41.6789 43.5786 41.6284 43.3993Z"
        fill="#007677"
      />
    </g>
  </svg>
);

export default IconOrientationChaiseArmFacingLeft;
